import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';

export const initialState = {
  messageDetails: {},
  messages: {},
  messagesListPaginationData: {
    offset: 0,
    initialLimit: 30
  },
  isFetchingMessagesList: true,
  isFetchingMoreMessages: false,
  isFetchingMessageDetails: true,

  isNotificationsListOpened: false,
  hasNotifications: false,
  hasMoreNotifications: false,
  notifications: [],
  notificationsPagination: {
    limit: 30,
    hasMoreNotifications: true
  },
  criticalNotifications: [],
  isLoadingNotifications: false,
  isNotificationsLoaded: false
};

export const useNotificationCenterStore = createHookStore(
  STORE_NAMES.NOTIFICATION_CENTER,
  initialState
);
